import type { NextPage } from 'next';
import Head from 'next/head';
import Box from '@components/Organizer/Box';

import MainLayout from '@source/components/MainLayout';
import Canvas from '@source/components/Organizer/Canvas';
import CreateEvent from '@source/components/Organizer/CreateEvent';
import Prices from '@source/components/Organizer/Prices';
import FAQ from '@source/components/Organizer/FAQ';
import CreateEventHero from '@source/components/Organizer/CreateEventHero';
import VideoContainer from '@source/components/Organizer/VideoContainer';

const Organizer: NextPage = (): JSX.Element => {
  return (
    <>
      <Head>
        <title>
          {
            'Organização para Eventos e Desafios de Ciclismo | Riderize - Conectados pelo Ciclismo'
          }
        </title>

        <link
          rel="preload"
          as="image"
          href={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/web/img/organizer-main.jpg?wdt=150&hgt=150`}
        />
      </Head>

      <MainLayout>
        <CreateEventHero />

        <Box
          title="Comodidade para seu atleta em um lugar só"
          text="Inscrições, pagamentos, classificação e outros tudo num lugar só. Fica fácil para o participante interagir com o seu evento."
          picture="picture3"
          label="Comece por aqui"
          imageLeft={true}
          alt="Ciclista ajustando cronômetro"
        />

        <Canvas />

        <VideoContainer />

        <Box
          title="Elimine a agonia das longas filas"
          text="Transforme seu smartphone num leitor de QRCode e ganhe velocidade na entrega de kits. Pare de usar planilhas manuais para encontrar inscrições. Além do atleta, o meio ambiente também agradece."
          picture="picture8"
          label="Criar prova"
          imageLeft={true}
          alt="Pessoas numa fila"
        />

        <Box
          title="O controle do evento está nas suas mãos"
          text="Você gerencia sua prova do celular ou computador, como quiser."
          picture="picture7"
          label="Crie o primeiro, é fácil"
          alt="Dois ciclistas olhando para um celular"
        />

        <Box
          title={`"Antes do Riderize, nossos eventos de auto navegação precisavam ser contabilizados de forma manual. Tentamos automatizar de várias formas, mas sem sucesso. Foi ai que entrou o Riderize e nos ajudou a construir uma solução automática e simples. Hoje nossos atletas tem uma experiência muito melhor e divertida. Só temos a agradecer a toda equipe Riderize pela parceria!"`}
          text='Alexandro do <a href="https://www.instagram.com/desc_mtb/" target="_blank">DESC</a>'
          picture="picture6"
          label="Criar prova"
          imageLeft={true}
          alt="Foto do Alexandro"
          longText
        />

        <CreateEvent />

        <Prices />

        <FAQ />
      </MainLayout>
    </>
  );
};

export default Organizer;
